import React from 'react';
///import { makeStyles } from '@material-ui/core/styles';
import { styled } from '@mui/material/styles';
import {Box, Container, Grid, Link, Button} from '@material-ui/core';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import LinearProgress from '@mui/material/LinearProgress';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import DoneIcon from '@mui/icons-material/Done';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import DialogCourseDetails from '../components/DialogCourseDetails';
import { makeStyles } from '@material-ui/core/styles';
import Header from "./HeaderMy";
import LeftDrawer from "../components/LeftDrawer";
import NotificationAlerts from "../components/NotificationAlerts";
import {API_URL,getWebPanelUrl,PAYMENT_GATEWAY_SUCCESS_URL,WEB_PANEL_URL} from '../utils/EnvVars';
import '../styles/bizofficer-a.css';
import UpdateEmail from '../components/UpdateEmail';
import Cookies from "js-cookie";
import NewTutorialButton from '../components/StudentTutorial/NewStudentTutorial';
import { useDispatch, useSelector } from 'react-redux';
import {setPopup } from "../store/popup.actions";

const useStyles = makeStyles((theme) => ({
	content: {
		[theme.breakpoints.up('md')]: {
		marginLeft:240,
		marginTop:60,
	  },
	  padding: theme.spacing(1),
	},
}));

const Accordion = styled((props) => (
	<MuiAccordion disableGutters elevation={0} square {...props} />
  ))(({ theme }) => ({
	border: `1px solid ${theme.palette.divider}`,
		  
	  borderRadius: 10,
	  marginBottom: 10,
	  backgroundColor: '#F7F7F7',
	
	'&:before': {
	  display: 'none',
	},
  }));
  
  const AccordionSummary = styled((props) => (
	<MuiAccordionSummary
	expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' , color: '#000000' }} />}
	  {...props}
	/>
  ))(({ theme }) => ({
	// backgroundColor: '#1f407a',
	// color: '#FFFFFF',
	flexDirection: 'row-reverse',
	'& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
	  transform: 'rotate(90deg)',
	},
	'& .MuiAccordionSummary-content': {
	  marginLeft: theme.spacing(1),
	},
  }));
  
  const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	padding: theme.spacing(2),
	borderTop: '1px solid rgba(0, 0, 0, .125)',
	backgroundColor: '#FFF',
	borderRadius: 10,
}));

export default function Execute() {
	const dispatch = useDispatch();
	const classes = useStyles();
	var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));
	const popup1 = useSelector((state => state?.popup1))
   const ftue = Cookies.get("ftue");
	
	const childRef = React.useRef();
	const childRefUpdateEmail = React.useRef();
	const [loadingPage, setLoadingPage] = React.useState(true);
	const [dataList, setDataList] = React.useState([]);
	const [expanded, setExpanded] = React.useState('panel0');
	const [dataDetail, setDataDetail] = React.useState({});
	const [selectedCourses, setSelectedCourses] = React.useState([]);
	const [packTypesRows, setPackTypesRows] = React.useState([]);
	const [packTypesRowz, setPackTypesRowz] = React.useState([]);
	const [selectedFlag, setSelectedFlag] = React.useState(0);
	const [newCourseOpt, setNewCourseOpt] = React.useState(0);
	const [newCoursePromoCode, setNewCoursePromoCode] = React.useState("");
	const [newCoursePackId, setNewCoursePackId] = React.useState(0);
	const authResult = new URLSearchParams(window.location.search); 
	const courseId = authResult.get('cid');

	const deviceType = authResult.get('device_type');
  	if(deviceType && deviceType.length>0){
    	localStorage.setItem("deviceType", deviceType);
  	}

	// check if logged in
	if(localStorage.getItem('etlStudentObj')===null){
		window.location.href='login';
	}


	const handleChange = (panel) => (event, newExpanded) => {
		setExpanded(newExpanded ? panel : false);
	};

	React.useEffect(() => {		
		if(etlStudentObj.loginId){
			getApiData(etlStudentObj.loginId, etlStudentObj.token);
			getMySelectedCourses(etlStudentObj.loginId, etlStudentObj.token);
			getPackTypesRows(etlStudentObj.loginId, etlStudentObj.token);
			getPackTypesRowz(etlStudentObj.loginId, etlStudentObj.token);
		}
	}, []); 

	React.useEffect(() => {					
			if(courseId && courseId>0 && dataList  && dataList.length>0){				
				for(let i=0; i<dataList.length; i++){
					if(dataList[i].coursesList.length>0){
						for(let j=0; j<dataList[i].coursesList.length; j++){
							// alert("XXX courseId: "+dataList[i].coursesList[j].courseId+"===="+courseId);
							if(dataList[i].coursesList[j] && dataList[i].coursesList[j].courseId && courseId==parseInt(dataList[i].coursesList[j].courseId)){
								// alert("AAA courseId: "+dataList[i].coursesList[j].courseId);
								if(isAddedCourse(courseId)==1){
									setDataDetail(dataList[i].coursesList[j]);
									setSelectedFlag(1);
									childRef.current.handleClickOpen();		
								}else{
									setDataDetail(dataList[i].coursesList[j]);
									setSelectedFlag(0);
									childRef.current.handleClickOpen();		
								}
							}
						}
					}
				}
			}
	}, [courseId,dataList]); 

	async function getApiData(loginId, token){
			let axiosHeader = {
				headers:{
					'Content-Type': 'multipart/mixed',
					'loginId': loginId,
					'token': token,
					'device': 'web'
				}
			};
			setLoadingPage(true);
			axios.get(API_URL+'/categoryandcourses', axiosHeader)
			   .then(response => {
				setLoadingPage(false);
				if(response.data && response.data.responseTxt==='success'){
					///document.write(JSON.stringify(response.data.obj));
					if(response.data.obj && response.data.obj?.length>0){
				 		setDataList(response.data.obj);
					}else{
						setDataList([]);
					}	
				}else if(response && response.data && response.data.responseTxt==="invalidToken"){
					window.localStorage.clear(); 
					window.location.href='logout';
				
				}			 				
			})
	}

	async function getMySelectedCourses(loginId, token){
		let axiosHeader = {
			headers:{
				'Content-Type': 'multipart/mixed',
				'loginId': loginId,
				'token': token,
				'device': 'web'
			}
		};
		axios.get(API_URL+'/myselectedcourses', axiosHeader)
		   .then(response => {
			if(response.data && response.data.responseTxt==='success'){
			   if(response.data.obj && response.data.obj?.length>0){
				  setSelectedCourses(response.data.obj);
			   }else{
				   setSelectedCourses([]);
			   }		

			} 			 				
		})
	}

	async function getPackTypesRows(loginId, token){
		let axiosHeader = {
			headers:{
				'Content-Type': 'multipart/mixed',
				'loginId': loginId,
				'token': token,
				'device': 'web'
			}
		};
		axios.get(API_URL+'/course-packtypes', axiosHeader)
		   .then(response => {
			if(response.data && response.data.responseTxt==='success'){
				///document.write(JSON.stringify(response.data.obj));
				if(response.data.obj && response.data.obj.length>0){
					setPackTypesRows(response.data.obj);
				}else{
					setPackTypesRows([]);
				}	
			} 			 				
		})
	}

	async function getPackTypesRowz(loginId, token){
		let axiosHeader = {
			headers:{
				'Content-Type': 'multipart/mixed',
				'loginId': loginId,
				'token': token,
				'device': 'web'
			}
		};
		axios.get(API_URL+'/course-packtypes?sortBy=id', axiosHeader)
		   .then(response => {
			if(response.data && response.data.responseTxt==='success'){
				///document.write(JSON.stringify(response.data.obj));
				if(response.data.obj && response.data.obj.length>0){
					setPackTypesRowz(response.data.obj);
				}else{
					setPackTypesRowz([]);
				}	
			} 			 				
		})
	}


	function showDetails(obj,selected){
		///document.write(JSON.stringify(obj));
		setDataDetail(obj);
		setSelectedFlag(selected);
		childRef.current.handleClickOpen();		
	}
	function selectMyNewCourse(opt,promoCode,packId){

		if(etlStudentObj && etlStudentObj?.loginId && opt>0){
			let axiosHeader = {
				headers:{
					'Content-Type': 'multipart/mixed',
					'loginId': etlStudentObj.loginId,
					'token': etlStudentObj.token,
					'device': 'web'
				}
			};
			//FREE Trial
			if(opt===1){
				axios.get(API_URL+'/selectmycourse?courseId='+dataDetail.courseId, axiosHeader)
					.then(response => {
						///console.log("Just Checking >> "+response.data);
						if(response && response.data && response.data.responseTxt==="success"){
							
							if(response.data.obj && response.data.obj?.length>0){
								let index = response.data.obj?.length-1;							
								window.localStorage.setItem("etlMyCourses", JSON.stringify(response.data.obj));
								window.localStorage.setItem("etlSelectCourse", index);
								///getApiDataLastOpenedCourseUpdate(response.data.obj[index].templateId);
								window.location.href='dashboard';

							}

						}else if(response && response.data && response.data.responseTxt==="invalidToken"){
							window.localStorage.clear(); 
							window.location.href='logout';
														   
					    }			 				
				}).catch((error) => {
					console.log("ERROR: ", error);
				})
			}else if(opt===2 || opt===3){
				//let apiQuery='&webUrl='+WEB_URL_COURSE;
				let apiQuery=''; 
				if(promoCode){
					apiQuery+='&promoCode='+promoCode;
				}
				let email = etlStudentObj.emailId;
				// if(!email || (email && email.length>0 && email==='null')){
				// 	email = "info@easetolearn.com";
				// }
				if(!email && localStorage.getItem("etlStudentEmailId") && localStorage.getItem("etlStudentEmailId").length>0){
					email = localStorage.getItem("etlStudentEmailId");
				}else if(!email || (email && email.length>0 && email==='null')){
					setNewCourseOpt(opt);
					setNewCoursePromoCode(promoCode);
					setNewCoursePackId(packId);
					childRefUpdateEmail.current.handleClickOpen(); 
					return false;
				}
				axios.get(API_URL+'/paymenttokengenerate-multiple-pricing?courseId='+dataDetail.courseId+'&courseTitle='+dataDetail.courseTitle+'&packId='+packId+apiQuery, axiosHeader)
					.then(response => {
						///console.log("Just Checking >> "+response.data);
						if(response && response.data && response.data.responseTxt==="success"){
							if(opt===3 && response.data.amount>0){
								//REDIRECT TO IN-APP PURCHASE					
								window.location.href='inapppayment?key='+response.data.key+'&txnid='+response.data.token+'&amount='+response.data.amount+'&firstname='+etlStudentObj.studentName+'&email='+etlStudentObj.emailId+'&phone='+etlStudentObj.phoneNo+'&productinfo='+response.data.productinfo+'&hash='+response.data.hashCode;
								return false;
							}else if(opt===2 && response.data.amount>0){	
								//REDIRECT TO PAYU PAYMENT GATEWAY					
								// window.location.href='http://localhost/rough-code/payment_8098.php?key='+response.data.key+'&txnid='+response.data.token+'&amount='+response.data.amount+'&firstname='+etlStudentObj.studentName+'&email='+etlStudentObj.emailId+'&phone='+etlStudentObj.phoneNo+'&productinfo='+response.data.productinfo+'&hash='+response.data.hashCode;
								// return false;
								document.pgform.key.value=response.data.key;
								document.pgform.txnid.value=response.data.token;
								document.pgform.amount.value=response.data.amount;
								document.pgform.firstname.value=etlStudentObj.studentName;
								document.pgform.email.value=email;
								document.pgform.phone.value=etlStudentObj.phoneNo;
								document.pgform.productinfo.value=response.data.productinfo;
								document.pgform.surl.value=PAYMENT_GATEWAY_SUCCESS_URL;
								document.pgform.furl.value=getWebPanelUrl()+'/pgcancelled';
								document.pgform.hash.value=response.data.hashCode;
								document.pgform.submit(); 

							}else if(response.data.organisations.length>0){ 
								let index = response.data.organisations.length-1;
								for(let i=0; i<response.data.organisations.length; i++){
									if(response.data.organisations[i].courseId===dataDetail.courseId){
										index = i;
										break;
									}
								}
								window.localStorage.setItem("etlMyCourses", JSON.stringify(response.data.organisations));
								window.localStorage.setItem("etlSelectCourse", index);
								///getApiDataLastOpenedCourseUpdate(response.data.organisations[index].templateId);
								window.location.href='dashboard';	

							}							
						}else if(response && response.data && response.data.responseTxt==="invalidToken"){
							window.localStorage.clear(); 
							window.location.href='logout';
														   
					    }			 				
				}).catch((error) => {
					console.log("AXIOS ERROR: ", error);
				})
			}
		}
	}


		

	function isAddedCourse(courseId) {
		for (let i = 0; i < selectedCourses.length; i++) {
		  if (selectedCourses[i] == courseId) return true;
		}
		return false;
	}

	
		return (
			<div> 
				<MetaTags>
            		<title>Select Course</title>
          		</MetaTags>
				
				<Header />	
				<LeftDrawer />
				<main className={classes.content}>
				<NotificationAlerts />
				
				{loadingPage?<LinearProgress />:null}

				<Box mt={1} ml={1}>
						<Grid container spacing={2}>
							<Grid item   md={12} xs={12}>
								<h3 className="heading" >Select Course</h3>
							</Grid>
						</Grid>
				</Box>				
				
				<Box m={1}>
						<Grid container spacing={2}>
							<Grid item   md={12} xs={12} className="MuiAccordionRoot" >
							{dataList?dataList.map((myRow,index)=>(	
								<Accordion expanded={expanded === 'panel'+(index+1)} onChange={handleChange('panel'+(index+1))}>
									<AccordionSummary aria-controls={"panel"+(index+1)+"d-content"} id={"panel"+(index+1)+"d-header"} >
									<Typography>{myRow.categoryName}</Typography>
									</AccordionSummary>
									<AccordionDetails>
									<Typography>
										<ul style={{listStyle:'none'}} >
											{
												myRow.coursesList.map((myTRow,indextt)=>(
													<li key={'intt'+indextt}>
														{isAddedCourse(myTRow.courseId)?<>
															<span style={{color: '#008000'}}><DoneIcon /> </span>
															<Link onClick={()=>{showDetails(myTRow,1)}} style={{cursor:'pointer',color:'#605959'}} title={myTRow.courseTitle+':- '+myTRow.courseSubTitle} >{myTRow.courseTitle} - {myTRow.courseSubTitle}</Link>
														</>
														:<>
															<span style={{color: '#605959'}}><ArrowRightIcon /> </span>
															<Link onClick={()=>{showDetails(myTRow,0)}} style={{cursor:'pointer',color:'#605959'}} title={myTRow.courseTitle+':- '+myTRow.courseSubTitle} >{myTRow.courseTitle} - {myTRow.courseSubTitle}</Link>
														</>
														}
													</li>
												))
											}	
										</ul>
									</Typography>
									</AccordionDetails>
								</Accordion>
							)):null}	

							</Grid>

						</Grid>
				</Box>

       

				
				<form name="pgform" action="https://secure.payu.in/_payment" method='post' >
					<input type="hidden" name="key" value="" />
					<input type="hidden" name="txnid" value="" />
					<input type="hidden" name="amount" value="" />
					<input type="hidden" name="productinfo" value="" />
					<input type="hidden" name="firstname" value="" />
					<input type="hidden" name="email" value="" />
					<input type="hidden" name="phone" value="" />					
					<input type="hidden" name="surl" value="" />
					<input type="hidden" name="furl" value="" />
					<input type="hidden" name="hash" value="" />
				</form>							
					



				</main>
				
				<DialogCourseDetails toCallSelectCourse={selectMyNewCourse} dataDetail={dataDetail} selectedFlag={selectedFlag} packTypesRows={packTypesRows} packTypesRowz={packTypesRowz} ref={childRef} />
				<UpdateEmail ref={childRefUpdateEmail} heading={etlStudentObj?.emailId?<>Update Email</>:<>Enter your email id</>} toCallSelectCourse={selectMyNewCourse} opt={newCourseOpt} promoCode={newCoursePromoCode} packId={newCoursePackId} />

				{ popup1  ? <NewTutorialButton /> : <></>}

			</div>
		);
 
}